import {
  setValuesAction,
  setVehicleData,
  showRegistrationInvalidAction,
  hideRegistrationInvalidAction,
  showConfirmationLayerAction,
  showLicenceNotFoundAction,
  hideLicenceNotFoundAction,
  disableButtonContinueAction,
  setTyreOptionsAction,
  enableButtonConfirmAction,
  disableButtonConfirmAction,
} from '../../_flux/actions/rego_lookup_actions';
import { Filters } from '../../_flux/constants/filter/filters';
import RegoLookupStore from '../../_flux/stores/rego_lookup_store';
import RegistrationPlateValidator from '../../validator/registration_plate_validator';
import { requestRegoLookup } from '../../_modules/requests/request_rego_lookup';
import { showAction as lockUi, hideAction as unlockUi } from '../../_flux/actions/ui_lock_actions';
import CheckoutConfiguratorAnalytics from '../../_modules/google_analytics/checkout_configurator';
import { requestSaveVehicleConfiguratorSelection } from '../../_modules/requests/request_save_vehicle_selection';
import CatalogFilterStore from '../../_flux/stores/catalog_configurator_store';
import { applyFilters } from '../../_flux/helper/apply_filters';
import { types } from '../../_constants/product/types';

export function onRegoLookupConfiguratorSubmitFactory() {
  return () => {
    const { values } = RegoLookupStore.getState();

    if (
      values.registration === '' ||
      (values.registration && RegistrationPlateValidator.validate(values.registration))
    ) {
      hideRegistrationInvalidAction();
      lockUi();
      CheckoutConfiguratorAnalytics.customerSubmittedContinueRegoLookupAction();
      requestRegoLookup(values)
        .then((response) => {
          let values = response;
          if (values.length > 0) {
            setValuesAction({
              ...values[0],
              [Filters.VEHICLE_TYRES]: '',
            });
            setTyreOptionsAction(values[0][Filters.VEHICLE_TYRES]);
            enableButtonConfirmAction();
            setVehicleData(values);
            hideLicenceNotFoundAction();
            showConfirmationLayerAction();
          } else {
            disableButtonConfirmAction();
            disableButtonContinueAction();
            showLicenceNotFoundAction();
          }

          unlockUi();
        })
        .catch(() => {
          disableButtonContinueAction();
          showLicenceNotFoundAction();
          unlockUi();
        });
    } else {
      showRegistrationInvalidAction();
    }
  };
}
